module.exports = new __parcel__URL__("eccodarwin-co2flux-monthgrid-v5.thumbnail.co2.5b5d64eb.png").toString();